"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ConditionOperator_1 = __importDefault(require("./ConditionOperator"));
const moment_1 = __importDefault(require("moment"));
const date_1 = require("../../utils/date");
class DateGeaterThan extends ConditionOperator_1.default {
    static get operatorKey() {
        return 'dateGreaterThan';
    }
    static get displayedName() {
        return 'Greater Than';
    }
    getFormattedDates({ value, comparedValue, conditionTriggerComponent }) {
        const validationFormat = conditionTriggerComponent && conditionTriggerComponent.component.type === 'day'
            ? (0, date_1.getDateValidationFormat)(conditionTriggerComponent.component)
            : null;
        const date = validationFormat ? (0, moment_1.default)(value, validationFormat) : (0, moment_1.default)(value);
        const comparedDate = validationFormat
            ? (0, moment_1.default)(comparedValue, validationFormat)
            : (0, moment_1.default)(comparedValue);
        return { date, comparedDate };
    }
    execute(options, functionName = 'isAfter') {
        const { value, instance, conditionComponentPath } = options;
        if (!value) {
            return false;
        }
        let conditionTriggerComponent = null;
        if (instance && instance.root) {
            conditionTriggerComponent = instance.root.getComponent(conditionComponentPath);
        }
        if (conditionTriggerComponent &&
            conditionTriggerComponent.component.type === 'day' &&
            (0, date_1.isPartialDay)(conditionTriggerComponent.component, value)) {
            return false;
        }
        const { date, comparedDate } = this.getFormattedDates(Object.assign(Object.assign({}, options), { conditionTriggerComponent }));
        return date[functionName](comparedDate);
    }
}
exports.default = DateGeaterThan;
